import { useMutation, useQueryClient } from 'react-query'
import ProjectService from '../../../services/ProjectService'

type DuplicateProjectPayload = {
  organization: string
  selectedProjects: string[]
}
export const useProjectBulkDuplicate = () => {
  const queryClient = useQueryClient()

  return useMutation<any, Error, DuplicateProjectPayload>({
    mutationKey: ['bulk-duplicate-project'],
    mutationFn: async ({ organization, selectedProjects }) => {
      await Promise.all(selectedProjects.map((name) => ProjectService.duplicateProject(organization, name)))
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projects'] })
      queryClient.invalidateQueries({ queryKey: ['projects-structure'] })
    },
  })
}
